import qs from 'qs'
import type { RequireAllOrNone } from 'type-fest'

type TailorMadeTourRequestFormParams = RequireAllOrNone<{
  tourOffer: App.Tours.TourV2Offer
  tourOfferVariation: App.Tours.TourV2OfferVariation
}, 'tourOffer' | 'tourOfferVariation'>

export function getTailorMadeTourRequestFormUrl({ tourOffer, tourOfferVariation }: TailorMadeTourRequestFormParams = {}): string {
  let url = '/tailor-made-tours/requests'
  if (tourOffer && tourOfferVariation) {
    url += `?${qs.stringify({
      tourOfferId: tourOffer.id,
      tourOfferVariationId: tourOfferVariation.id,
    })}`
  }

  return url
}

export function getTailorMadeTourRequestUrl(requestId: string): string {
  return `/tailor-made-tours/requests/${requestId}`
}
